module.exports = __webpack_public_path__ + "static/media/DKK.2fb1ab53.jpeg";